import * as React from 'react';
import styled from 'styled-components';

import { useLanguage } from 'core/hooks';
import { AppLanguage } from 'core/state/languageState';
import { Colors } from 'services/ColorService';

const LANGUAGES: AppLanguage[] = ['ru', 'pl'];

/** Compact RU / PL toggle for the menu — switches the UI language at runtime. */
export const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <Group>
      {LANGUAGES.map((lang) => (
        <LangButton
          key={lang}
          type="button"
          isActive={language === lang}
          onClick={() => setLanguage(lang)}
        >
          {lang.toUpperCase()}
        </LangButton>
      ))}
    </Group>
  );
};

const Group = styled.div`
  display: flex;
  border: 1px solid ${Colors.SecondLightGray};
  border-radius: 6px;
  overflow: hidden;
`;

const LangButton = styled.button<{ isActive: boolean }>`
  border: none;
  cursor: pointer;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  background: ${({ isActive }) => (isActive ? Colors.Blue : Colors.White)};
  color: ${({ isActive }) => (isActive ? Colors.White : Colors.Gray)};

  &:not(:last-child) {
    border-right: 1px solid ${Colors.SecondLightGray};
  }
`;
